// TODO: File is Obsolete and will need to be removed after this is deployed to production and updated.
import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import AddToListModal from "@insite/content-library/Components/AddToListModal";
import Page from "@insite/mobius/Page";
import * as React from "react";

const PrivacyPolicyPage: React.FunctionComponent<PageProps> = ({ id }: PageProps) => (
    <Page data-test-selector="privacyPolicyPage" padding={0}>
        <Zone contentId={id} zoneName="Content" />
        <AddToListModal />
    </Page>
);

const pageModule: PageModule = {
    component: PrivacyPolicyPage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
        pageType: "Content",
    },
};

export default pageModule;

export const PrivacyPolicyPageContext = "PrivacyPolicyPage";
